import React from 'react';
import { useTimer } from '../hooks/useTimer';
import { useAlert } from '../context/alertContext';


const Timer = ({ qrCodeImage, copiaColaPix, tempoExpiracao, onExpire }) => {

  const { showAlert } = useAlert();
  const contagem = useTimer(tempoExpiracao, onExpire);

  if (!tempoExpiracao) return null;

  return (
    <div>

      <img src={qrCodeImage} alt="QR Code Pix" style={{ width: 200, height: 200 }} />

      {copiaColaPix && (
        <div className='top-margin' style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <p><strong>Código Pix:</strong></p>
          <textarea
            readOnly
            value={copiaColaPix}
            style={{ width: "100%", height: "80px" }}
          />
          <p
            type="button"
            style={{ cursor: "pointer" }}
            onClick={() => {
              showAlert("PIX copiado!", "tempo", "ok");
              navigator.clipboard.writeText(copiaColaPix);
            } }
          >
            Copiar
          </p>
        </div>
      )}

      <p className='top-margin'>Expira em: {contagem}</p>

    </div>
  );
};

export default Timer;
